import { useEffect, useState } from "react";
import TextTransition, { presets } from "react-text-transition";
import { motion } from "framer-motion";
import Button from "../../components/ui/Button";

const HeroSection = () => {
  const TEXTS = [
    "Web Application",
    "Mobile Application",
    "Automation",
    "Softwares",
  ];
  const [index, setIndex] = useState(0);
  
  useEffect(() => {
    const intervalId = setInterval(() => setIndex((index) => index + 1), 2000);
    return () => clearTimeout(intervalId);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.div
      className="pt-12 500:pt-16 950:pt-20 pl-p83 pb-12 500:pb-16 950:grid 950:grid-cols-2 flex flex-wrap-reverse gap-6 500:gap-8 950:justify-between min-h-[90vh] items-center"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div className="px-0.5 space-y-6" variants={itemVariants}>
        <motion.div
          className="text-2xl 325:text-3xl font-merry-bold tracking-tight 500:text-3xl 700:text-4xl 950:text-5xl leading-tight"
          variants={itemVariants}
        >
          <div className="grid gap-x-0 550:flex 550:gap-x-2 950:grid 950:gap-x-0 1400:flex 1400:gap-2 flex-wrap">
            <span className="text-neutral-100">Building</span>
            <motion.span
              className="text-primary-500 font-merry-bold tracking-tight text-xl 280:text-2xl 325:text-2xl 500:text-3xl 700:text-4xl 950:text-5xl relative inline-block"
              variants={itemVariants}
            >
              <TextTransition springConfig={presets.wobbly}>
                {TEXTS[index % TEXTS.length]}
              </TextTransition>
              <motion.div
                className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-primary-500 to-primary-300 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: "100%" }}
                transition={{ duration: 0.5, delay: 0.5 }}
              />
            </motion.span>
          </div>
          <motion.span
            className="text-neutral-100 block mt-2"
            variants={itemVariants}
          >
            That Drives Company Success
          </motion.span>
        </motion.div>

        <motion.p
          className="text-neutral-300 text-sm 500:text-base max-w-xl font-poppins-regular leading-relaxed"
          variants={itemVariants}
        >
          Transform your business with cutting-edge digital solutions. We deliver
          innovative software that drives growth and success.
        </motion.p>

        <motion.div variants={itemVariants} className="flex gap-3 500:gap-4 mt-4 500:mt-6">
          <Button
            href="#contact"
            variant="primary"
            size="lg"
            className="shadow-premium hover:shadow-premium-lg"
          >
            Get A Free Consult
          </Button>
          <Button
            href="#services"
            variant="outline"
            size="lg"
          >
            Our Services
          </Button>
        </motion.div>
      </motion.div>

      <motion.div
        className="flex-col flex relative overflow-hidden"
        variants={itemVariants}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        <div className="relative overflow-visible">
          <motion.div
            className="flex w-full justify-end relative z-10"
            animate={{
              y: [0, -20, 0],
            }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            <img
              src="/Mockup.svg"
              alt="Nexasoft Infotech - Modern Software Development Services on MacBook Display"
              className="z-50 relative pr-7 width__resp drop-shadow-2xl"
            />
          </motion.div>
          <motion.img
            src="Background_Images/device_bg.svg"
            alt="Device"
            className="absolute bottom-0 right-0 width__resp opacity-60"
            animate={{
              scale: [1, 1.05, 1],
              opacity: [0.6, 0.8, 0.6],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
          {/* Decorative gradient orb */}
          <motion.div
            className="absolute right-0 top-0 w-96 h-96 bg-primary-400 rounded-full opacity-20 blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.2, 0.3, 0.2],
            }}
            transition={{
              duration: 5,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        </div>
      </motion.div>
    </motion.div>
  );
};

export default HeroSection;
